
import LandingHeader from './home/LandingHeader.vue';
import LandingFooter from './home/LandingFooter.vue';
import SidebarView from './home/SidebarView.vue';
import PlatformServices from './home/PlatformServices.vue';
import WhatIsGio from './home/WhatIsGio.vue';
import SponsorsRow from './home/SponsorsRow.vue';
import { scrollToComponent, scrollToTop } from './home/utils';
import { ref, onMounted, onBeforeUnmount } from 'vue';

export default {
  components: {
    LandingHeader,
    LandingFooter,
    SidebarView,
    PlatformServices,
    WhatIsGio,
    SponsorsRow,
  },
  setup() {
    const op = ref(false);
    const about = ref(null);
    const platform = ref(null);
    const testimonials = ref(null);
    const faq = ref(null);
    const isMobile = ref<null | boolean>(null);
    const startLink = ref();

    const currentCampaign = {
      name: "RAID: Shadow Legends",
      amount: 21,
      logoPath: "../../assets/raid-logo.png" // not in use currently
    };

    const closeSidebar = () => {
      op.value = !op.value;
    };
    const checkIsMobile = () => {
      isMobile.value = window.innerWidth <= 768;
    };

    onMounted(() => {
      checkIsMobile();
    });
    onBeforeUnmount(() => {
      window.removeEventListener('resize', checkIsMobile);
    });
    window.addEventListener('resize', checkIsMobile);

    return {
      currentCampaign,
      closeSidebar,
      checkIsMobile,
      scrollToComponent,
      scrollToTop,
      startLink,
      testimonials,
      platform,
      isMobile,
      about,
      faq,
      op,
    };
  },
}
